import { StudentLibraryCubit } from '@breakoutlearning/firebase-repository/cubits/StudentLibraryCubit'
import { PageTitle } from 'components/PageTitle'
import { FullPageSpinner } from 'components/Spinner'
import { useTranslationTyped } from 'i18n/i18n'
import { useRepository } from 'hooks/auth'
import { useCubitBuilder } from 'hooks/cubits'
import { useImpersonatedBreakoutUser } from 'hooks/profile'
import { useRootStore } from 'hooks/rootStore'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

export const DemoWelcomePage = observer(function DemoWelcomePage() {
  const { tt } = useTranslationTyped()
  const rootStore = useRootStore()
  const repository = useRepository()
  const impersonatedBreakoutUser = useImpersonatedBreakoutUser()

  const libraryCubit = useCubitBuilder(
    () => new StudentLibraryCubit(repository, impersonatedBreakoutUser),
    [repository, impersonatedBreakoutUser]
  )

  useEffect(() => {
    if (!libraryCubit.roomStates.isLoaded) return

    const roomStates = libraryCubit.roomStates.models
      .filter((roomState) => {
        return roomState.data.isDemo
      })
      .sort((a, b) => {
        // sort most recent first
        const [aUpdated, bUpdated] = [a.data.updatedAt, b.data.updatedAt]
        if (aUpdated && bUpdated) return bUpdated.getTime() - aUpdated.getTime()
        if (aUpdated) return -1
        if (bUpdated) return 1
        return 0
      })

    const first = roomStates.length ? roomStates[0] : null

    if (first) {
      rootStore.navigateToDemoWaitingRoom(first.id)
    } else {
      rootStore.navigateTo('logout')
    }
  }, [
    rootStore,
    libraryCubit.roomStates.isLoaded,
    libraryCubit.roomStates.models,
  ])

  return (
    <>
      <PageTitle title={tt.demo.page_title()} />
      <FullPageSpinner reason="demo_welcome_loading" />
    </>
  )
})
